import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const Toolbar = ({ children }) => <div className="toolbar">{children}</div>;

Toolbar.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default Toolbar;
